import { SearchFilterType } from '~/components/TableFilters/types';
import { ALL_CLIENT_TYPES } from './ClientsPage.utils';
const coversEveryOption = (value, optionCount)=>!Array.isArray(value) || value.length === 0 || value.length === optionCount;
export const clientsFilterConfig = (param)=>{
    let { statusFilterOptions, typeFilterOptions } = param;
    return {
        status: {
            type: SearchFilterType.MultiSelectFilter,
            removable: false,
            options: [
                ...statusFilterOptions
            ],
            mobile: {
                isEmptyValue: (value)=>coversEveryOption(value, statusFilterOptions.length)
            }
        },
        type: {
            type: SearchFilterType.MultiSelectFilter,
            removable: false,
            options: [
                ...typeFilterOptions
            ],
            mobile: {
                isEmptyValue: (value)=>coversEveryOption(value, typeFilterOptions.length)
            }
        }
    };
};
export const clientsFilterSelection = (param)=>{
    let { filters, statusFilterOptions } = param;
    const selectedStatus = filters.status;
    const selectedType = filters.type;
    return {
        status: (selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.length) ? selectedStatus : statusFilterOptions.map((option)=>option.value),
        type: (selectedType === null || selectedType === void 0 ? void 0 : selectedType.length) ? selectedType : ALL_CLIENT_TYPES
    };
};
